if (!customElements.get('store-rating')) {
  customElements.define(
    'store-rating',
    class StoreRating extends HTMLElement {
      connectedCallback() {
        this.fillEl = this.querySelector('[data-rating-fill]');
        this.textEl = this.querySelector('[data-rating-text]');
        const id = this.dataset.shopId;
        const key = this.dataset.publicKey;
        if (!id || !key || !this.fillEl || !this.textEl) return;

        this.cacheKey = 'wwk-rating-' + id;
        const cached = this.readCache();
        if (cached) {
          this.render(cached.avg, cached.amount);
          return;
        }

        const url =
          'https://dashboard.webwinkelkeur.nl/api/1.0/ratings_summary.json?id=' +
          encodeURIComponent(id) +
          '&public_code=' +
          encodeURIComponent(key);

        fetch(url)
          .then((response) => response.json())
          .then((json) => {
            if (!json || json.status !== 'success' || !json.data) return;
            let avg = parseFloat(json.data.rating_average);
            const amount = parseInt(json.data.amount, 10);
            if (!isFinite(avg) || !isFinite(amount) || amount < 1) return;
            // WebwinkelKeur geeft een 10-schaal terug; omrekenen naar 5 sterren.
            if (avg > 5) avg = avg / 2;
            this.writeCache(avg, amount);
            this.render(avg, amount);
          })
          .catch(() => {});
      }

      readCache() {
        try {
          const cached = JSON.parse(sessionStorage.getItem(this.cacheKey));
          if (cached && Date.now() - cached.t < 6 * 3600 * 1000) return cached;
        } catch (error) {
          /* leeg */
        }
        return null;
      }

      writeCache(avg, amount) {
        try {
          sessionStorage.setItem(this.cacheKey, JSON.stringify({ t: Date.now(), avg: avg, amount: amount }));
        } catch (error) {
          /* leeg */
        }
      }

      render(avg, amount) {
        const locale = this.dataset.locale || document.documentElement.lang || 'nl';
        this.fillEl.style.width = Math.min(100, (avg / 5) * 100) + '%';
        const ratingLabel = (Math.round(avg * 10) / 10).toLocaleString(locale, {
          minimumFractionDigits: 1,
          maximumFractionDigits: 1,
        });
        this.textEl.textContent = (this.dataset.template || '[rating] · [aantal] reviews')
          .replace('[rating]', ratingLabel)
          .replace('[aantal]', amount);
        this.classList.add('is-active');
      }
    }
  );
}
